import styled from "styled-components";
import { Input } from "antd";
import { CardElement } from "@stripe/react-stripe-js";

export const CreditCardInput = styled(Input)`
  height: 60px;
  margin: 10px 0px !important;
  font-size: 16px;
  border: 1px solid #e4e4e4;

  & .ant-input {
    font-size: 16px;
  }
`;

export const NameOnCard = styled(CreditCardInput)`
  padding: 4px 20px;
`;

// styling for stripe's card elements
export const CardElementsStyling = {
  style: {
    base: {
      color: "#32325d",
      fontFamily: '"Helvetica Neue", Helvetica, sans-serif',
      fontSmoothing: "antialiased",
      fontSize: "16px",
      "::placeholder": {
        color: "#aab7c4",
      },
    },
    invalid: {
      color: "#fa755a",
      iconColor: "#fa755a",
    },
  },
  hidePostalCode: true,
};

export const CustomCardElement = styled(CardElement)`
  &.StripeElement {
    margin: 12px 0px;

    box-sizing: border-box;

    height: 60px;

    padding: 10px 12px;

    border: 1px solid #e4e4e4;
    border-radius: 2px;
    background-color: white;

    display: flex;
    align-items: center;
    -webkit-transition: box-shadow 150ms ease;
    transition: box-shadow 150ms ease;
  }

  &.StripeElement * {
    width: 100%;
  }

  &.StripeElement--focus {
    border-width: 1px;
    border-color: #40a9ff;
    box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
  }

  &.StripeElement--invalid {
    border-color: #fa755a;
  }

  &.StripeElement--webkit-autofill {
    background-color: #fefde5 !important;
  }
`;
